import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";

import EmptyState from "../../components/EmptyState";
import Button from "../../components/Button";
import messages from "../../assets/locale/messages";
import noImgPlaceholder from "../../assets/images/placeholders/emptyBox.svg";
import { getNotificationsRequest } from "../../store/Notifications/actions";
import { formatDate } from "../../utils/Helpers";
import {
  handleNotificationClick,
  markAllNotificationsAsRead
} from "../../notifications/helpers";
import defaultNotificationIcon from "../../assets/images/vectors/info-icon.svg";

const Notifications = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isLoading = useSelector((state) => state.loader.showLoader);
  const lang = useSelector((state) => state.locale.lang);
  const { notifications } = messages[lang];

  const notificationsList = useSelector(
    (state) => state.notifications.notificationsList
  );
  const notificationsMeta = useSelector(
    (state) => state.notifications.notificationsMeta
  );

  const [page, setPage] = useState(1);

  useEffect(() => {
    dispatch(getNotificationsRequest({ params: { page } }));
  }, [page]);

  const onClickNotification = ({
    Id,
    ActionId,
    ClickActionName,
    IsRead
  }) => {
    handleNotificationClick({
      id: Id,
      clickAction: ClickActionName,
      actionId: ActionId,
      isRead: IsRead,
      navigate
    });
  };

  const handleMarkAllAsRead = () => {
    markAllNotificationsAsRead({ request: "complete" });
  };

  return (
    <div className="notifications-page-container">
      <div className="page-title pb-4 d-flex justify-content-between align-items-center">
        <h4 className="mb-0 title-color fsize-22 fweight-700">
          {notifications.notifications}
        </h4>
        <div
          className="light-blue-bg px-4 py-3 border-radius-8 box-shadow-hover pointer"
          onClick={handleMarkAllAsRead}>
          <span className="text-primary fweight-500">
            {notifications.markAllAsRead}
          </span>
        </div>
      </div>
      <div className="notifications-container bg-white border-radius-8 py-3">
        {notificationsList?.length
          ? notificationsList.map(
              (
                {
                  Id,
                  Title,
                  Body,
                  ClickActionName,
                  ActionId,
                  CreatedDate,
                  IsRead,
                  Image
                },
                i
              ) => (
                <div
                  className={`notification-item pointer px-4 ${!IsRead && "grey-bg"}`}
                  key={`list-notification-item-${i}`}
                  onClick={() =>
                    onClickNotification({
                      Id,
                      ActionId,
                      ClickActionName,
                      IsRead
                    })
                  }>
                  <div
                    className={`d-flex align-items-md-center align-items-start justify-content-between flex-column flex-md-row py-3 ${i < notificationsList.length - 1 && "light-border-bottom"}`}>
                    <Box
                      className="content d-flex align-items-center justify-content-start"
                      sx={{
                        maxWidth: {
                          xs: "100%",
                          sm: "80%",
                          lg: "85%"
                        }
                      }}>
                      <div className="me-2">
                        <img
                          src={
                            Image
                              ? `data:image/svg+xml;utf8,${encodeURIComponent(Image)}`
                              : defaultNotificationIcon
                          }
                          style={{ width: "2.8rem" }}
                        />
                      </div>
                      <div className="text">
                        <p className="mb-0 fsize-15 fweight-600 text-color">
                          {Title}
                        </p>
                        <p className="mb-0 fsize-12 text-light-grey">
                          {Body}
                        </p>
                      </div>
                    </Box>
                    <div className="date mt-3 me-0 ms-auto m-md-0">
                      <span className="fsize-12 fweight-300 text-light-grey">
                        {formatDate(
                          CreatedDate,
                          false,
                          "DD MMM YYYY | hh:mm a"
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              )
            )
          : !isLoading && (
              <div>
                <EmptyState
                  subTitle={notifications.noNotifications}
                  imgSrc={noImgPlaceholder}
                />
              </div>
            )}
      </div>
      {notificationsList?.length < notificationsMeta?.count && (
        <div className="load-more-section w-100 d-flex justify-content-center my-4">
          <Button
            label={notifications.loadMore}
            outlined
            onClick={() => setPage(page + 1)}
          />
        </div>
      )}
    </div>
  );
};

export default Notifications;
